module.exports = __webpack_public_path__ + "static/media/logo-dl.5801ebee.png";